/** eslint-disable */
import Vue from 'vue';
import { api, toast } from '@/services';

export default {
  async fetchNotificacoes({ commit }) {
    const response = await api.get('/notificacoes');
    commit('SET_NOTIFICACOES', response.data);
  },
  async fetchConfiguracoesUsuario({ commit }) {
    const response = await api.get('/notificacoes/configuracoes');
    commit('SET_CONFIGURACOES', response.data);
  },
  async salvarConfiguracoesUsuario(_, payload) {
    try {
      await api.post('/notificacoes/configuracoes', payload);
      Vue.$toast.success('Atualizado com sucesso');
    } catch (e) {
      toast.error(e);
    }
  },
  filtrar({ commit }, filtro) {
    commit('FILTRAR', filtro);
  },
};
